/* import __COLOCATED_TEMPLATE__ from './pill.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();